"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationReason = void 0;
var CancellationReason;
(function (CancellationReason) {
    CancellationReason["REASON_UNKNOWN"] = "REASON_UNKNOWN";
    CancellationReason["DUPLICATE_ORDER"] = "DUPLICATE_ORDER";
    CancellationReason["UNAVAILABLE_ITEM"] = "UNAVAILABLE_ITEM";
    CancellationReason["FRAUDULENT_EATER"] = "FRAUDULENT_EATER";
    CancellationReason["RESTAURANT_INTERNAL_ISSUE"] = "RESTAURANT_INTERNAL_ISSUE";
    CancellationReason["KITCHEN_CLOSED"] = "KITCHEN_CLOSED";
    CancellationReason["CUSTOMER_CALLED_TO_CANCEL"] = "CUSTOMER_CALLED_TO_CANCEL";
    CancellationReason["CANNOT_COMPLETE_CUSTOMER_REQUEST"] = "CANNOT_COMPLETE_CUSTOMER_REQUEST";
    CancellationReason["RESTAURANT_TOO_BUSY"] = "RESTAURANT_TOO_BUSY";
    CancellationReason["UNACCEPTED_ORDER"] = "UNACCEPTED_ORDER";
    CancellationReason["RESTAURANT_CANCELED"] = "RESTAURANT_CANCELED";
    CancellationReason["AUTOMATICALLY_CANCELED"] = "AUTOMATICALLY_CANCELED";
    CancellationReason["LATE_DELIVERY"] = "LATE_DELIVERY";
    CancellationReason["COURIER_NOT_FOUND"] = "COURIER_NOT_FOUND";
    CancellationReason["CUSTOMER_NOT_FOUND"] = "CUSTOMER_NOT_FOUND";
    CancellationReason["UNABLE_TO_DELIVER"] = "UNABLE_TO_DELIVER";
})(CancellationReason = exports.CancellationReason || (exports.CancellationReason = {}));
